import './index.scss'

interface ModuleContTs {
    section: number
    title?: string | number
    children?: JSX.Element
    style?: React.CSSProperties
}

export default function ModuleCont(props: ModuleContTs) {
    const {
        section,
        title = '',
        children,
        style = {},
    } = props
    
    return (
        <div className='plan_detail_module' id={`section${section}`} style={style}>
            <div className="colorBack"></div>
            <div className="file_cont">
                <div className="title">
                    {title}
                </div>
                {children}
            </div>
        </div>
    )
}
